export const STEPS = {
    tipo: 'tipo',
    denunciante: 'denunciante',
    receptor: 'receptor',
    denuncia: 'datos-denuncia',
    testigo: 'testigo',
    archivos: 'archivos',
    finalizar: 'finalizar-denuncia'
}
